import { DragEndEvent, useDndMonitor } from '@dnd-kit/core';
import { CalendarCellDropTarget, DragObject, DroppedItemType } from '../common';
import { useTabId } from '../../../keep-alive/TabContext';
import { getCurrentlyOpenedTabId } from '@lmt/unicorn-shared/app/features/navigation/operations';

export function useItemDroppedToCalendarCell(
  callback: (
    itemId: number,
    itemType: DroppedItemType,
    cell: CalendarCellDropTarget,
  ) => void,
) {
  const tabId = useTabId();
  useDndMonitor({
    onDragEnd(event: DragEndEvent) {
      if (!event.over) {
        return;
      }
      if (getCurrentlyOpenedTabId() !== tabId) return;
      const cellData = event.over.data.current as DragObject;
      if (cellData?.type !== 'calendar-cell') {
        return;
      }

      const data = event.active.data.current as DragObject;
      if (data?.type === 'patient') {
        callback(data.patientId, 'patient', cellData);
      } else if (data?.type === 'visit') {
        callback(data.visitId, 'visit', cellData);
      } else {
        console.log(event.active, data);
        console.log('Something was dropped to calendar (but not a patient)');
      }
    },
  });
}
